import { getCurrentProfile } from "../services/multipleProfilesService";
export async function isHidePromptForKidsProfile() {
  const currentProfile = await getCurrentProfile();
  if (currentProfile && currentProfile?.profileCategory === "KIDS") {
    return true;
  }
  return false;
}
